import {
  Button,
  Grid,
} from "@mui/material";

import Section from "./components/Section";
import DetailGrid from "./components/DetailGrid"
import GlobalDefaultBidfloorForm from "./forms/GlobalDefaultBidfloorForm";

import { useState } from "react";

const getDetailGridProps = ({ default_bidfloor, isEditing, formProps }) => {
  const firstColumn = {
    title: "Default Bid Floor (CPM)",
    description: (!isEditing ? `$${default_bidfloor}` : (
      <GlobalDefaultBidfloorForm defaultBidfloor={default_bidfloor} {...formProps} />
    ))
  }

  const props = {
    PaperProps: { sx: { backgroundColor: "white" } },
    disableBadge: true,
    columns: [
      firstColumn,
      { title: "Description", description: "Default bid floor for all incoming bids that does not have a bid floor" }
    ]
  }

  return props
}

const EditButton = ({ onClick }) => (
  <Button sx={{ alignSelf: "self-end" }} variant="contained" size="small" onClick={onClick}>Edit</Button>
)

const GlobalProgrammaticMarginSection = ({ value }) => {
  const [isEditing, setIsEditing] = useState(false);
  const handleEditClick = (event) => setIsEditing((prev) => !prev);
  const hideEditForm = () => setIsEditing(false);

  return (
    <Section title={"Default Bid Floor"} actionButton={<EditButton onClick={handleEditClick} />}>
      <Grid container item xs={12}>
        <Grid item xs={12} sx={{ borderRadius: 2, display: "flex", flexDirection: "row" }}>
          <DetailGrid
            {...getDetailGridProps({ isEditing, default_bidfloor: value, formProps: { onCancel: hideEditForm } })}
          />
        </Grid>
      </Grid>
    </Section>
  )
}

export default GlobalProgrammaticMarginSection;
